namespace TabAurous.ECommerce {
}
